import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';



const PetPhotoMagic = () => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { t } = useTranslation();




    return (

        <>
            <Helmet>
                <title>Pet Photo Magic – AI-Powered Anime Transformations for Your Furry Friends</title>
                <meta name="description" content="Bring your pet photos to life with our AI-powered Pet Photo Magic service! Transform your beloved companion into a majestic royal, a playful superhero, or a whimsical anime character with just a few taps. Our advanced AI technology allows you to: Change Backgrounds Instantly, Swap Outfits and Accessories,Create Artistic Portraits,Apply Fun Filters and Effects" />
                {/* <meta name="keywords" content={t('lostandfound.meta_keywords')} /> */}
            </Helmet>

            <Container>
                <Row>
                    <Col md={12} className="p-4">
                        <h3>{t("Pet Photo Magic – AI-Powered Anime Transformations for Your Furry Friends")}</h3>
                        <p className="lead">
                            {t("Bring your pet photos to life with our AI-powered Pet Photo Magic service! Transform your beloved companion into a majestic royal, a playful superhero, or a whimsical anime character with just a few taps. Our advanced AI technology allows you to: Change Backgrounds Instantly, Swap Outfits and Accessories,Create Artistic Portraits,Apply Fun Filters and Effects")}                </p>


                        < img
                            loading="lazy"
                            style={{ maxWidth: '300px', height: 'auto' }}
                            className="img-fluid rounded mb-4 center"
                            src="/assets/web/5-min.png"
                            alt="Pet photo anime | Pets Home App"
                        />

                        <img
                            loading="lazy"
                            style={{ maxWidth: '300px', height: 'auto' }}
                            className="img-fluid rounded mb-4 center"
                            src="/assets/web/4-min.png"
                            alt="Pet photo anime | Pets Home App"
                        />


                        <img
                            loading="lazy"
                            style={{ maxWidth: '300px', height: 'auto' }}
                            className="img-fluid rounded mb-4 center"
                            src="/assets/web/3-min.png"
                            alt="Pet photo anime | Pets Home App"
                        />

                        <img
                            loading="lazy"
                            style={{ maxWidth: '300px', height: 'auto' }}
                            className="img-fluid rounded mb-4 center"
                            src="/assets/web/6-min.png"
                            alt="Pet photo anime | Pets Home App"
                        />
                    </Col>
                </Row>





            </Container>
        </>
    );
};

export default PetPhotoMagic;
